import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Apis } from "../../config";
import apiService from "../../services/ApiService";

const fetchYouMightlikeProductItems = createAsyncThunk('youmightlike/fetchYouMightlikeProductItems', async (data, { rejectWithValue }) => {
    try {
        let response = await apiService.get(Apis.GetYoumaylikeProductData(data))
        return response
    } catch (err) {
        return rejectWithValue(err?.message || 'Failed to fetch you might like list items');
    }
});

export const youMightLikeThunks = { fetchYouMightlikeProductItems };

